import { computed, Injectable, Signal, signal } from '@angular/core';

import { SessionService } from '../session.service';
import type { AppRole, Session } from '../session.model';

/**
 * Development stand-in (R-004): a fixed, immutable InternalAdmin session.
 * Mints no token, reads no storage, calls nothing — it must not be mistaken
 * for a production identity source. Selected only when AppConfig.mockAuth is
 * true; unreachable otherwise (asserted by session.providers.spec).
 */
@Injectable()
export class DevSessionService extends SessionService {
  private readonly fixed = signal<Session>({
    isAuthenticated: true,
    roles: ['InternalAdmin'],
    displayName: 'Development user',
    clientCode: null,
  });

  readonly session: Signal<Session> = this.fixed.asReadonly();
  readonly isAuthenticated: Signal<boolean> = computed(() => this.session().isAuthenticated);

  /** Constant: the stand-in mints one session at startup and never changes owner. */
  readonly sessionEpoch: Signal<number> = signal(1).asReadonly();

  constructor() {
    super();
    console.warn(
      'DevSessionService: development session stand-in active (mockAuth: true). ' +
        'This is not a production identity source.',
    );
  }

  hasAnyRole(roles: readonly AppRole[]): boolean {
    return roles.some((role) => this.session().roles.includes(role));
  }
}
